<template>
  <div class="other-tours__item">
    <AppLink :to="newLink"> {{ link.title }} </AppLink>
  </div>
</template>

<script lang="ts" setup>
  import { type Link } from '@/shared/models';

  const props = defineProps<{
    link: Link;
  }>();

  const newLink = props?.link?.slug ? `/tours/russia/category/${props.link.slug}/` : '';
</script>

<style scoped lang="scss">
  @use '@experience/design-tokens/typography';
  @use '@experience/shared/dist/assets/adaptivity';

  .other-tours__item {
    overflow: hidden;
    padding-bottom: var(--alias-space-8);
    word-break: break-word;

    @include typography.base-400-400-regular;

    @include adaptivity.desktop-xs {
      &:nth-child(n + 10) {
        display: none;
      }
    }

    @include adaptivity.tablet {
      &:nth-child(n + 5) {
        display: none;
      }
    }

    @include adaptivity.mobile {
      &:nth-child(n + 5) {
        display: none;
      }
    }

    @media only screen and (min-width: 1280px) {
      &:nth-child(n + 9) {
        display: none;
      }
    }
  }

  a {
    color: var(--alias-color-link-default);
    text-decoration: none;
  }
</style>
